import { IChWhitelistCheckParams, IChWhitelistSignature } from 'types';
import { API } from 'api/API';
import { appConfig } from 'config';

export function getChWhitelistSignature(params: IChWhitelistCheckParams): Promise<IChWhitelistSignature> {
  return API.get<IChWhitelistSignature>(`${appConfig.apiUrl}/getCHWLSignature`, { params }).then(
    (response) => response.data,
  );
}
